import { baseApi } from './baseApi'
import type { LoginRequest, LoginResponse, GetMeResponse } from '../../types'

export const authApi = baseApi.injectEndpoints({
	endpoints: (builder) => ({
		login: builder.mutation<LoginResponse, LoginRequest>({
			query: (credentials) => ({
				url: '/login',
				method: 'POST',
				body: credentials,
			}),
		}),

		getMe: builder.query<GetMeResponse, void>({
			query: () => ({
				url: '/me',
				method: 'GET',
			}),
			providesTags: ['User'],
		}),

		logout: builder.mutation<{ message?: string }, void>({
			query: () => ({
				url: '/logout',
				method: 'POST',
			}),
			invalidatesTags: ['User'],
		}),

		logoutAll: builder.mutation<{ message?: string }, void>({
			query: () => ({
				url: '/logout-all',
				method: 'POST',
			}),
			invalidatesTags: ['User'],
		}),
	}),
})

export const {
	useLoginMutation,
	useGetMeQuery,
	useLogoutMutation,
	useLogoutAllMutation,
} = authApi

